export default __webpack_public_path__ + "static/media/050-life-jacket.682fff68.png";